// extracted by mini-css-extract-plugin
export default {"card":"Card_card__z8HfQ","cardHeader":"Card_cardHeader__-l-pg","cardTitle":"Card_cardTitle__mAKjQ","cardSubtitle":"Card_cardSubtitle__dA-r+"};